var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.articleInfo)?_c('div',{staticClass:"widget-article-card-wrapper"},[_c('ArticleItem',{attrs:{"item":_vm.articleInfo,"link-target":"_blank"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }